module.exports = __webpack_public_path__ + "img/mind_skeleton_102.f88518d7.png";